var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputSoilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1824_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04503 0C6.78199 0.746411 0 4.62201 0 4.62201V8.72727L7.65513 13.378V24H9.76936V12.2067L2.1307 7.59617V5.7244L8.04503 2.30813C14.4975 6.01722 15.2279 6.43636 15.2279 6.43636V4.12249C12.2241 2.41722 8.04503 0 8.04503 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03485 5.48328L5.84375 6.74069L13.433 11.1043V14.8019L11.9393 15.4393V17.9713C12.8564 17.4431 13.8833 17.0756 15.2287 16.3062V12.9187V9.61725C12.6807 8.15313 8.03485 5.48328 8.03485 5.48328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 12.3043L0.0113509 14.8421L5.44243 17.9713V15.4507L0.00585938 12.3043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1824_740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2279,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSoilIcon);
export default __webpack_public_path__ + "static/media/inputSoilIcon.8149f3c53e83d61e0ef0032b7e336858.svg";
export { ForwardRef as ReactComponent };